export default __webpack_public_path__ + "static/3-9eee41e35db3413b65decbfb64e69252.jpg";